import { Pipe, PipeTransform } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { isDevMode } from '@angular/core';

/**
 * Looks up a transloco translation under a namespace.
 *
 *   {{ language.language | enumLabel: 'languages' }}
 *
 * The canonical path is exact-case (`languages.German`); we also try the
 * lower-case variant once because some endpoints return `Beginner` while
 * the i18n keys are written as `beginner`. If neither key resolves we
 * return the raw value so the UI never leaks `languages.German` to end
 * users — and emit a dev-mode warning so the missing key surfaces during
 * development rather than silently masking a BE/i18n misalignment.
 */
@Pipe({
  name: 'enumLabel',
  standalone: true,
  pure: false,
})
export class EnumLabelPipe implements PipeTransform {
  constructor(private readonly transloco: TranslocoService) {}

  transform(value: string | null | undefined, namespace: string): string {
    if (value === null || value === undefined || value === '') return '';
    if (!namespace) return value;

    const tryKeys = [
      `${namespace}.${value}`,
      `${namespace}.${value.toString().toLowerCase()}`,
    ];

    for (const key of tryKeys) {
      const translated = this.transloco.translate(key);
      if (translated && translated !== key) return translated;
    }

    if (isDevMode()) {
      console.warn(`[enumLabel] no translation for "${namespace}.${value}" — falling back to raw value`);
    }
    return value.toString();
  }
}
